/**
 * Utility function to format price amounts using Intl.NumberFormat
 * 
 * @param amount - The numeric amount to format
 * @param currency - The currency code (e.g., 'USD', 'EUR', 'GBP', 'JPY')
 * @param locale - Optional locale string (defaults to browser's locale)
 * @returns Formatted price string (e.g., '$12.34', '€12,34', '£12.34', '¥1234')
 */
export function formatPrice(amount: number, currency: string, locale?: string): string {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency
  }).format(amount)
}
